<p-drawer
  [(visible)]="visible"
  position="bottom"
  styleClass="!h-auto max-h-[80vh]"
  appendTo="body"
>
  @if (headerTemplate()) {
    <ng-template pTemplate="header">
      <ng-container *ngTemplateOutlet="headerTemplate()!" />
    </ng-template>
  }
  <ng-content />
</p-drawer>
